import { fromByteArray, toByteArray } from "base64-js";
import StringBase64 from "js-base64";

const Base64Converter = {
    fromByteArray,
    // base64-js always allocates a fresh ArrayBuffer, so narrow the (ArrayBufferLike) @types
    // return to Uint8Array<ArrayBuffer> — required since TS 5.7 made TypedArrays generic over
    // their buffer, otherwise the result is not assignable to BlobPart at ~16 call sites.
    toByteArray: (base64: string): Uint8Array<ArrayBuffer> => toByteArray(base64) as Uint8Array<ArrayBuffer>,

    fromString: (plainText: string) => StringBase64.Base64.encode(plainText),
    toString: (base64Encoded: string) => StringBase64.Base64.decode(base64Encoded) 
};

export default Base64Converter;